import type { Task } from "@app/core";
import { type ClaudeClient, extractText, MODELS } from "./client.js";
import { SUMMARIZE_DAY_SYSTEM } from "./prompts/summarize-day.js";

/** Produce a short natural-language summary of the day's tasks. */
export async function summarizeDay(
  client: ClaudeClient,
  tasks: Task[],
  now: Date = new Date(),
): Promise<string> {
  const compact = tasks.map((t) => ({
    title: t.title,
    due_at: t.due_at,
    status: t.status,
    priority: t.priority,
  }));
  const res = await client.messages.create({
    model: MODELS.sonnet,
    // Sonnet 5 thinks by default, and `max_tokens` caps thinking + answer
    // TOGETHER — a short cap would be eaten by reasoning and truncate the
    // summary. This is a one-shot restatement of a list, not a reasoning task.
    thinking: { type: "disabled" },
    max_tokens: 400,
    system: [
      { type: "text", text: SUMMARIZE_DAY_SYSTEM, cache_control: { type: "ephemeral" } },
    ],
    messages: [
      {
        role: "user",
        content: `Current datetime: ${now.toISOString()}\nTasks:\n${JSON.stringify(compact, null, 2)}`,
      },
    ],
  });
  return extractText(res);
}
